import { t } from "i18next";
import { FormikProvider, Form, Field } from "formik";
import FormikTextField from "../../components/HangingProtocol/FormikATextField";
import { ACTIONS } from "../../constants/Constants"

const Details = (props) => {
  const {
    values,
  } = props.formik;
  
  return (
    <FormikProvider value={props.formik}>
    <Form>
    <div className="tab-section">
      <div>
        <div className="form-section-header">
          <p>{t("hanging-protocol.details")}</p>
        </div>
        {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) &&
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
          <Field
              name="name"
              value={values.name}
              placeholder={t("hanging-protocol.name")}
              label={t("hanging-protocol.name")}
              parentClassName={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3"}
              component={FormikTextField}
              autoFocus={true}
              allErrors={props.allErrors}
              required={true}
            />
          </div>
          <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
          <Field
              name="description"
              value={values.description}
              placeholder={t("hanging-protocol.description")}
              label={t("hanging-protocol.description")}
              parentClassName={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg3"}
              component={FormikTextField}
              autoFocus={false}
              allErrors={props.allErrors}
              required={false}
            />
          </div>
        </div>
        }
        {props.action === ACTIONS.VIEW &&
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-heading">{t("hanging-protocol.name")}</div>
              <div className="form-mt-10">{values.name}</div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="form-heading">{t("hanging-protocol.description")}</div>
              <div className="form-mt-10">{values.description}</div>
            </div>
          </div>
        }
      </div>
      </div>
    </Form>
    </FormikProvider>
  );
};

export default Details;
